import { createSlice } from '@reduxjs/toolkit';
import { TAB_CATEGORIES } from '../enums';

const competitionTabState = createSlice({
  name: 'competitionTab',
  initialState: TAB_CATEGORIES,
  reducers: {
    setCompetitionTab(state, action) {
      return action.payload;
    }
  }
});

export const { setCompetitionTab } = competitionTabState.actions;
export default competitionTabState.reducer;